// HEPI cart: slide-in drawer + add/change/remove through Shopify's AJAX Cart API.
// Used by product cards, the product page (addToCartAjax) and the header bag icon.
//
// The drawer total is the products total. snippets/hepi-ship-box keeps a hidden
// .hepi-ship span with the variant ids of the two hidden service products:
//   data-asm = assembly (הרכבה במקום), data-pk = pickup (איסוף עצמי, free, 1000 kg).
// Those lines are never listed with the furniture and never counted in the bag
// badge. If the furniture is all removed, they go with it.
(function(){
  var WA='972525649250';
  var drawer,bd,body,foot,totalEl,countEl,waEl,asmBox,lastFocus;
  var ASM=0,PK=0;

  function money(cents){
    var n=cents/100;
    return n.toLocaleString('en-US',{minimumFractionDigits:(n%1)?2:0,maximumFractionDigits:2})+' ₪';
  }
  function esc(s){
    return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});
  }
  function sized(url){return url?url+(url.indexOf('?')>-1?'&':'?')+'width=200':'';}
  function toast(msg){if(window.showToast)window.showToast(msg);}
  function isAsm(it){return ASM&&it.variant_id===ASM;}
  function isHid(it){return isAsm(it)||(PK&&it.variant_id===PK);}

  function setBadge(count){
    document.querySelectorAll('.cart-n').forEach(function(el){el.textContent=count;el.hidden=count===0;});
  }

  function lineHtml(it,i){
    if(isHid(it))return '';
    var line=i+1;
    return '<li class="hepi-line">'+
      '<a class="hepi-line__img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(sized(it.image))+'" alt="" loading="lazy">':'')+'</a>'+
      '<div class="hepi-line__info">'+
        '<a class="hepi-line__title" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+
        (it.product_has_only_default_variant===false&&it.variant_title?'<div class="hepi-line__var">'+esc(it.variant_title)+'</div>':'')+
        '<div class="hepi-line__row">'+
          '<div class="hepi-qty" role="group" aria-label="כמות עבור '+esc(it.product_title)+'">'+
            '<button type="button" data-line="'+line+'" data-qty="'+(it.quantity+1)+'" aria-label="הוספת יחידה">+</button>'+
            '<span>'+it.quantity+'</span>'+
            '<button type="button" data-line="'+line+'" data-qty="'+(it.quantity-1)+'" aria-label="הסרת יחידה">−</button>'+
          '</div>'+
          '<strong class="hepi-line__price" dir="ltr">'+money(it.final_line_price)+'</strong>'+
        '</div>'+
        '<button type="button" class="hepi-line__remove" data-line="'+line+'" data-qty="0">הסרה</button>'+
      '</div>'+
    '</li>';
  }

  function render(cart){
    var asmLine=0,hidLine=0,goods=0;
    cart.items.forEach(function(it,i){if(isHid(it)){hidLine=i+1;if(isAsm(it))asmLine=i+1;}else{goods+=it.quantity;}});
    setBadge(goods);
    // Only service lines left means the furniture was removed: take them out too.
    if(hidLine&&!goods){return change(hidLine,0);}
    if(!drawer)return cart;
    countEl.textContent=goods?'('+goods+')':'';
    if(!goods){
      body.innerHTML='<div class="hepi-drawer__empty"><i class="ti ti-shopping-bag" aria-hidden="true"></i><p>הסל ריק כרגע</p><a class="happi-btn" href="/collections/all">להתחיל לקנות</a></div>';
      foot.hidden=true;
      return cart;
    }
    body.innerHTML='<ul class="hepi-line-list" role="list">'+cart.items.map(lineHtml).join('')+'</ul>';
    if(totalEl)totalEl.textContent=money(cart.total_price);
    if(asmBox)asmBox.checked=!!asmLine;
    var names=cart.items.filter(function(it){return !isHid(it);}).map(function(it){return it.product_title+' ×'+it.quantity;}).join(', ');
    waEl.href='https://wa.me/'+WA+'?text='+encodeURIComponent('שלום, יש לי שאלה לפני שאני מזמין/ה: '+names+(asmLine?' (עם הרכבה)':''));
    foot.hidden=false;
    return cart;
  }

  function refresh(){
    return fetch('/cart.js?_='+Date.now(),{cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(render);
  }

  function change(line,qty){
    if(body)body.classList.add('is-busy');
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){if(!r.ok)throw new Error('change failed');return r.json();})
      .then(render)
      .catch(function(){toast('לא הצלחנו לעדכן את הסל. נסו שוב');return refresh();})
      .then(function(){if(body)body.classList.remove('is-busy');});
  }

  /* Tick = add the assembly service once; untick = remove its line. */
  function setAssembly(on){
    if(!ASM)return Promise.resolve();
    if(body)body.classList.add('is-busy');
    return fetch('/cart.js?_='+Date.now(),{cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var line=0;cart.items.forEach(function(it,i){if(isAsm(it))line=i+1;});
      if(on&&!line){
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:ASM,quantity:1})})
          .then(function(r){if(!r.ok)throw new Error('add failed');}).then(refresh);
      }
      if(!on&&line){return change(line,0);}
      return render(cart);
    }).catch(function(){toast('לא הצלחנו לעדכן את ההרכבה. נסו שוב');return refresh();})
      .then(function(){if(body)body.classList.remove('is-busy');});
  }

  function open(){
    if(!drawer)return;
    lastFocus=document.activeElement;
    bd.hidden=false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    var c=drawer.querySelector('[data-cart-close]');if(c)c.focus();
  }
  function close(){
    if(!drawer)return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    bd.hidden=true;
    document.body.style.overflow='';
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }

  /* A message inside the drawer, for when something went wrong. Never silent:
     a failed add used to fail quietly, which looks exactly like an empty cart. */
  function notice(msg){
    if(!drawer){toast(msg);return;}
    body.innerHTML='<div class="hepi-drawer__empty"><i class="ti ti-alert-circle" aria-hidden="true"></i><p>'+esc(msg)+'</p>'+
      '<a class="hepi-drawer__wa" href="https://wa.me/'+WA+'" target="_blank" rel="noopener"><i class="ti ti-brand-whatsapp" aria-hidden="true"></i> להזמין בוואטסאפ</a></div>';
    foot.hidden=true;
    open();
  }

  function add(variantId,btn,qty){
    var orig=btn?btn.innerHTML:'';
    if(btn){btn.disabled=true;btn.innerHTML='<i class="ti ti-loader-2" aria-hidden="true"></i> מוסיף...';}
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:variantId,quantity:qty||1})})
      .then(function(r){return r.json().catch(function(){return {};}).then(function(j){
        if(!r.ok)throw new Error(j.description||j.message||('HTTP '+r.status));
        return j;
      });})
      .then(refresh)
      .then(function(cart){
        // Added, yet the cart comes back empty: the browser is not keeping the
        // cart cookie (blocked cookies, or the page shown inside another site).
        if(cart&&cart.item_count===0){notice('המוצר נוסף, אבל הדפדפן לא שומר את הסל. נסו לרענן את העמוד או לפתוח את האתר בדפדפן אחר.');return;}
        if(drawer){open();}else{toast('נוסף לסל');}
      })
      .catch(function(err){notice('לא הצלחנו להוסיף לסל'+(err&&err.message?': '+err.message:'')+'.');})
      .then(function(){if(btn){btn.disabled=false;btn.innerHTML=orig;}});
  }

  window.hepiCart={open:open,close:close,add:add,change:change,refresh:refresh,setAssembly:setAssembly};
  window.addToCartAjax=function(id,btn){return add(id,btn,1);};
  window.updateCartCount=refresh;

  document.addEventListener('DOMContentLoaded',function(){
    var box=document.querySelector('.hepi-ship');
    if(box){ASM=parseInt(box.getAttribute('data-asm'),10)||0;PK=parseInt(box.getAttribute('data-pk'),10)||0;}
    drawer=document.getElementById('hepiCart');
    if(drawer){
      bd=document.getElementById('hepiCartBD');
      body=document.getElementById('hepiCartBody');
      foot=document.getElementById('hepiCartFoot');
      totalEl=drawer.querySelector('.hepi-ship__total');
      asmBox=drawer.querySelector('.hepi-ship__asm');
      countEl=document.getElementById('hepiCartCount');
      waEl=document.getElementById('hepiCartWa');
      bd.addEventListener('click',close);
      drawer.addEventListener('click',function(e){
        var b=e.target.closest('[data-line]');
        if(b){change(parseInt(b.getAttribute('data-line'),10),parseInt(b.getAttribute('data-qty'),10));return;}
        if(e.target.closest('[data-cart-close]'))close();
      });
      if(asmBox)asmBox.addEventListener('change',function(){setAssembly(asmBox.checked);});
      document.querySelectorAll('.hdr-cart').forEach(function(a){
        a.addEventListener('click',function(e){e.preventDefault();refresh().then(open);});
      });
    }
    // The header badge is printed by Liquid with the raw item count, which
    // includes the service lines; one refresh corrects it on every page.
    refresh();
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&drawer&&drawer.classList.contains('is-open'))close();
    });
  });
  window.addEventListener('pageshow',function(e){if(e.persisted)refresh();});
})();
